var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"block mr-1",attrs:{"id":"pagetitle"}},[_c('div',{staticClass:"inner"},[_c('h1',{class:_vm.titleClass ? _vm.titleClass : 'pt-4 pb-2'},[_vm._t("default")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }